import React, { useState } from 'react'
import styles from './modal.module.css'
import Loader from 'components/Loader'
import { Button, IconButton, Box, TextField, InputAdornment, OutlinedInput, } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear';
import * as api from '../../pages/services/api'
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

function ModalConfirmEditProfile({ onSubmit, onClose }) {
    const [loading, setLoading] = useState(false)
    const [password, setPassword] = useState('')
    const [textAlert, setTextAlert] = useState('')

    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };

    const confirmPassword = async () => {
        setLoading(true)
        let res = await api.confirmPassword(password)
        setLoading(false)
        if (res) {
            if (res['data']['code'] == 200) {
                setTextAlert('')
                onSubmit()
                onClose()
            } else {
                setTextAlert('รหัสผ่านไม่ถูกต้อง')
            }
        } else {
            setTextAlert('')
            alert('ไม่ตอบสนอง')
        }
    }

    return (
        <>
            <Loader loading={loading} />
            <Box className={styles.backgroundModal}>
                <Box className={styles.boxModal}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', gridGap: '10px' }}>
                            <Box sx={{ border: '5px solid #478F96' }} />
                            <Box sx={{
                                fontWeight: 600,
                                fontSize: '18px',
                                color: '#478F96',
                                "@media (max-width: 800px)": {
                                    fontSize: '16px',
                                }
                            }}>ยืนยันการแก้ไข</Box>
                        </Box>
                        <Box sx={{ '&:hover': { cursor: 'pointer' } }}>
                            <IconButton onClick={() => { onClose() }}>
                                <ClearIcon />
                            </IconButton>
                        </Box>
                    </Box>

                    <Box sx={{ display: 'grid', textAlign: 'center', gridGap: '25px' }}>
                        <Box sx={{ textAlign: 'start' }}>
                            <Box>รหัสผ่าน</Box>
                            {/* <TextField
                                size='small'
                                fullWidth
                                placeholder='รหัสผ่าน'
                                value={password}
                                onChange={(e) => { setPassword(e.target.value) }}
                            /> */}
                            <OutlinedInput
                                id="outlined-adornment-password"
                                type={showPassword ? "text" : "password"}
                                placeholder='รหัสผ่าน'
                                variant="outlined"
                                size="small"
                                fullWidth
                                value={password}
                                onChange={(e) => { setPassword(e.target.value) }}
                                endAdornment={
                                    <InputAdornment position="end" >
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            onMouseUp={handleMouseUpPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                            {textAlert &&
                                <Box sx={{
                                    fontSize: '12px',
                                    color: '#E06262',
                                }}>{textAlert}</Box>
                            }
                        </Box>
                        <Box>
                            <Button
                                variant='contained'
                                onClick={() => {
                                    if (!password) return alert('กรอกรหัสผ่าน')
                                    confirmPassword()
                                }
                                }
                            >ยืนยัน</Button>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </>
    )
}

export default ModalConfirmEditProfile
